<template>
  <div class="home">
    <div class="oeamtc">
      <OeamtcHero
        headline="ÖAMTC Online Terminvergabe"
        subheadline="Keine Lust auf lange Warteschlangen? Mit der Online-Terminvergabe des ÖAMTC können Sie Ihren Wunschtermin einfach und bequem von Zuhause aus buchen."
        :headlineLevel="1"
      >
        <template #media>
          <picture class="hero-picture-container">
            <source media="(max-width: 767px)" :srcset="heroImageMobile" />
            <img
              class="hero-picture"
              :src="heroImage"
              alt="ÖAMTC Terminvergabe"
              width="1440"
              height="316"
              loading="eager"
            />
          </picture>
        </template>
      </OeamtcHero>
    </div>
    <div class="home__container">
      <template v-if="user">
        <Reminder />
        <BookAppointments />
        <FuturePastAppointments />
      </template>
      <template v-else>
        <LoginSection />
        <hr />
        <BookAppointments />
      </template>
      <hr />
      <PopularServices />
    </div>
  </div>
</template>

<script>
import BookAppointments from '@/components/Home/BookAppointments.vue'
import FuturePastAppointments from '@/components/Home/FuturePastAppointments.vue'
import LoginSection from '@/components/Home/LoginSection.vue'
import PopularServices from '@/components/Home/PopularServices.vue'
import Reminder from '@/components/Home/Reminder.vue'
import { mapGetters } from 'vuex'
import { OeamtcHero } from '@oeamtc/styleguide-vuejs-lib-ui'
import heroImage from '@/assets/images/home-header.jpg'
import heroImageMobile from '@/assets/images/home-header-mobile.jpg'

export default {
  components: {
    BookAppointments,
    FuturePastAppointments,
    Reminder,
    LoginSection,
    PopularServices,
    OeamtcHero,
  },
  data() {
    return {
      heroImage,
      heroImageMobile,
    }
  },
  mounted() {
    this.$store.commit('setActiveStep', 0)
    this.$store.dispatch('clearBookingState')
  },
  computed: {
    ...mapGetters(['user', 'userHasPaid', 'federalStates']),
    outstanding() {
      return !this.userHasPaid
    },
  },
  methods: {},
}
</script>

<style lang="scss">
.hero-picture-container {
  display: block;
  width: 100%;
}

.hero-picture {
  display: block; // Removes inline baseline gap
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;

  // Desktop: Aspect ratio based on actual image size (1440x316)
  @media (min-width: 768px) {
    aspect-ratio: 1440 / 316;
    max-height: 350px; // Styleguide maximum
  }

  // Mobile: Aspect ratio based on mobile image (480x334)
  @media (max-width: 767px) {
    aspect-ratio: 480 / 334;
    max-height: 265px; // Styleguide maximum
  }
}

.home {
  @include flex-center-align;
  flex-direction: column;
  background-color: $color-grey-lightest;

  &__container {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 4px;
    margin-bottom: 64px;
    margin-top: 64px;
    max-width: 856px;
    padding: 40px 72px;
    width: 100%;

    @media (max-width: 856px) {
      border-radius: 0;
      margin-bottom: 0;
      margin-top: 0;
    }

    @media (max-width: $breakpoint-max-tablet) {
      padding: 32px 16px;
    }

    > hr {
      @include container-divider;
    }
  }
}
</style>
